
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button }from '@cmsgov/design-system';


// Utils

import { normalizeAddress } from '@utils/normalize/normalizeAddress';

const PreferencesPageAddressViewer = props => {

    const {
        mailingAddress,
        getLinkToDashboard,
        handleMailingAddressExtension,
        mailingAddressUpdateAllowed
    } = props;

    return (
        <div className="my-3">
            <div className='grid-row align-items-center'>
                <span className='tablet:grid-col-3 required-true p-4'>
                    <FormattedMessage
                        id='common.mailing_address'
                    />
                </span>
                <div className='tablet:grid-col-9 grid-row align-items-center p-4'>
                    <span data-test-id="preferences_mailing_address">{normalizeAddress(mailingAddress)}</span>
                    {mailingAddressUpdateAllowed && <div className="text-start">
                        <Button className="usa-button gi-button gi-button__outline margin-l-20" onClick={handleMailingAddressExtension}>
                            <FontAwesomeIcon icon="edit" />
                            <FormattedMessage id="ssap.button.change_address" />
                        </Button>
                    </div>}
                </div>
            </div>
            {!mailingAddressUpdateAllowed &&
                <div className="usa-alert usa-alert--warning mx-4">
                    <div className="usa-alert__body">
                        <p className="usa-alert__text">
                            <FormattedMessage
                                id='preferences_page.report_address_via_application'
                                values={{
                                    link: getLinkToDashboard(
                                        <FormattedMessage
                                            id='common.back_to_dashboard'
                                        />
                                    )
                                }}
                            />
                        </p>
                    </div>
                </div>}
        </div>
    );
};

export default PreferencesPageAddressViewer;